import * as utils from '@utils/form';

export const FORM_FIELDS = {
  IMAGE: {
    name: 'image',
    rules: [{ required: true, message: 'Image is required' }],
    serialize: utils.imageSerialize,
    deserialize: utils.imageDeserialize,
  },
  PAGE: {
    label: 'Links to:',
    placeholder: 'Enter a URL or start typing the name of the page',
    entityName: 'page',
    urlName: 'url',
    rules: [{ required: true, message: 'URL or page is required' }],
    serialize: utils.entityOrUrlFieldSerialize,
  },
};
